module.exports = __webpack_public_path__ + "static/media/abeuk.2a525c12.jpg";